var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RNavChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,12 C9.8,12 8,13.8 8,16 L8,27 C8,29.2 9.8,31 12,31 L18,31 L16.2,37 L24,31 L36,31 C38.2,31 40,29.2 40,27 L40,16 C40,13.8 38.2,12 36,12 Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,19.2 A2,2 0,1 0,14.5,23.2 A2,2 0,1 0,14.5,19.2",
    fill: "#0D0D12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8,19.2 A2,2 0,1 0,23.8,23.2 A2,2 0,1 0,23.8,19.2",
    fill: "#00D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1,19.2 A2,2 0,1 0,33.1,23.2 A2,2 0,1 0,33.1,19.2",
    fill: "#7C1CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,34.5 A5.2,5.2 0,1 0,30.5,44.9 A5.2,5.2 0,1 0,30.5,34.5",
    fill: "#FFD000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6,35.8 L31.6,43.1 L29.8,43.1 L29.8,40.2 L27.2,40.2 L27.2,38.5 L29.8,38.5 L29.8,35.8 Z",
    fill: "#0D0D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RNavChat);
export default __webpack_public_path__ + "static/media/p4r_nav_chat.983898898850dc46bb5f750ec604d22d.svg";
export { ForwardRef as ReactComponent };